<template>
  <a
    :class="{ [classes.disabled]: disabled }"
    :href="hrefOption"
    :target="target"
    @click="handleClick"
  >
    <slot></slot>
  </a>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { defineComponent, computed } from "vue";
import { injectRuntimeConfig } from "@fresh8/ad-data-composition/src/runtimeConfig";

const useStyles = createUseStyles({
  disabled: {
    cursor: "auto"
  }
});

export default defineComponent({
  name: "LinkWrapper",
  props: {
    href: { type: String },
    target: { type: String },
    disabled: { type: Boolean, required: false, default: false }
  },
  setup(props) {
    const runtimeConfig = injectRuntimeConfig();
    const classes = useStyles();

    return {
      classes,
      hrefOption: computed(() =>
        runtimeConfig.value.enableLinks ? props.href : ""
      ),
      handleClick(e: Event) {
        if (!runtimeConfig.value.enableLinks || props.disabled) {
          e.preventDefault();
        } else {
          e.stopPropagation();
        }
      }
    };
  }
});
</script>
